import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { useHistory } from "react-router-dom";
import Cart from "../components/Cart";
import ClientInfoForm from "./components/ClientInfoForm";
import { updateClientInfo } from '../../redux/actions/clientActions';

import "./ClientPage.scss"


const ClientPage = ({ updateClientInfo, clientInfo, branchInfo, currentDeliveryType }) => {

  const history = useHistory();
  const onSaveClientInfo = (data) => {
    updateClientInfo(data);
    history.push(`/${branchInfo.branch_guid_code}/payment`);
  };


  return (
    <div className={`shop client-details`} id="shop">
      <div className="client-info">
          <ClientInfoForm
            formSubmit={ onSaveClientInfo }
            formData={ clientInfo }
            currentDeliveryType = { currentDeliveryType }
            branchInfo={ branchInfo }
          />
      </div>

      <div className="order-info">
        <Cart editable={false}/>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    clientInfo,
    branchInfo,
    currentDeliveryType
  } = state;

  return {
    clientInfo,
    branchInfo,
    currentDeliveryType
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateClientInfo
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(ClientPage);
